import { createContext, useContext, useMemo } from 'react';
import { METADATA_MAP_BY_LEGACY_SIDEBAR_CARD_TYPE } from '../constants/LegacySidebarCardMetadata';
import { LEGACY_SIDEBAR_CARD_TYPES } from '../constants/LegacySidebarCardType';
const ExtraCardPropsContext = /*#__PURE__*/createContext(undefined);
export const ExtraCardPropsContextProvider = ExtraCardPropsContext.Provider;

// For backwards compatiblity. These types returned true in `isLegacyCardTypeWithExtraCardProps`,
// despite not having an extra props config type in our types, or being included in LegacyCardTypesUsingExtraProps.
const HAS_EXTRA_PROPS_OVERRIDE = [LEGACY_SIDEBAR_CARD_TYPES.OrderDiscountCard, LEGACY_SIDEBAR_CARD_TYPES.OrderShipmentDetailCard, LEGACY_SIDEBAR_CARD_TYPES.OrderTotalCard];
function isLegacyCardTypeWithExtraCardProps(cardType) {
  var _METADATA_MAP_BY_LEGA;
  return ((_METADATA_MAP_BY_LEGA = METADATA_MAP_BY_LEGACY_SIDEBAR_CARD_TYPE[cardType]) === null || _METADATA_MAP_BY_LEGA === void 0 ? void 0 : _METADATA_MAP_BY_LEGA.hasLegacyExtraProps) || HAS_EXTRA_PROPS_OVERRIDE.includes(cardType);
}
export function useExtraCardProps(legacyCardType) {
  const allExtraCardProps = useContext(ExtraCardPropsContext);
  const extraCardProps = useMemo(() => {
    if (!allExtraCardProps) {
      return undefined;
    }
    if (!isLegacyCardTypeWithExtraCardProps(legacyCardType)) {
      return {};
    }
    return allExtraCardProps[legacyCardType];
  }, [allExtraCardProps, legacyCardType]);
  if (extraCardProps === undefined) {
    return {};
  }
  return extraCardProps;
}